<script>
export default {
  name: "RemarkInputView",
  props: {
    value: String,
    disabled: Boolean
  },
  data() {
    return {
      hahaData: [
        {
          s1: {k1: "携带电脑", k2: "", k3: "台"},
          s2: {k1: "携带工具包", k2: "", k3: "个"},
          s3: {k1: "携带存储设备", k2: "", k3: "台"},
        }
      ]
    }
  },
  computed: {
    message() {
      return this.value; // 使用传入的值
    }
  },
  methods: {
    updateMessage(event) {
      this.$emit('input', event); // 更新父组件的值
    },
    querySearch(queryString, cb) {
      let results = this.hahaData
      cb(results);
    },

    handleSelect(msg) {
      console.log(msg)
      let data = ""
      if (msg.s1.k2 > 0) {
        data += msg.s1.k1 + msg.s1.k2 + msg.s1.k3 + "，"
      }
      if (msg.s2.k2 > 0) {
        data += msg.s2.k1 + msg.s2.k2 + msg.s2.k3 + "，"
      }
      if (msg.s3.k2 > 0) {
        data += msg.s3.k1 + msg.s3.k2 + msg.s3.k3 + "，"
      }
      this.$emit('input', data); // 更新父组件的值
    },

    handleIconClick(ev) {
      console.log(ev);
    },
    childrenClick(event) {
      event.stopPropagation(); // 阻止事件传播

    }
  }
}
</script>

<template>
  <div>
    <el-autocomplete
        style="width: 100%"
        popper-class="my-autocomplete"
        :value="value"
        :fetch-suggestions="querySearch"
        @input="updateMessage"
        :disabled="disabled"
        @select="handleSelect">
      <i
          class="el-icon-edit el-input__icon"
          slot="suffix"
          @click="handleIconClick">
      </i>
      <template slot-scope="{ item }">
        <div class="name">
          <div>
            <span class="mr-1">{{ item.s1.k1 }}</span>
            <el-input-number class="" size="mini" v-model="item.s1.k2" :min="0" label="描述文字" @click.native="childrenClick"></el-input-number>
            <span class="ml-1">{{ item.s1.k3 }}</span>
          </div>
          <div>
            <span class="mr-1">{{ item.s2.k1 }}</span>
            <el-input-number class="" size="mini" v-model="item.s2.k2" :min="0" label="描述文字" @click.native="childrenClick"></el-input-number>
            <span class="ml-1">{{ item.s2.k3 }}</span>
          </div>
          <div>
            <span class="mr-1">{{ item.s3.k1 }}</span>
            <el-input-number class="" size="mini" v-model="item.s3.k2" :min="0" label="描述文字" @click.native="childrenClick"></el-input-number>
            <span class="ml-1">{{ item.s3.k3 }}</span>
          </div>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<style scoped lang="less">

</style>
